import { useState } from "react";
import { axios } from "@root/libs/axios";
import { csrfToken } from "@root/shared/utils/csrf";
import { sendErrorLog } from "@root/shared/utils/sendErrorLog";

const HIDDEN_ON = 1;
const HIDDEN_OFF = 2;

const STATUS_OK = 1;
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- レスポンス型の判別値として typeof 参照でのみ使用する
const STATUS_NG = 0;

type Response = {
  data: {
    on: typeof HIDDEN_ON | typeof HIDDEN_OFF;
  };
  exception: string | null;
  status: typeof STATUS_OK | typeof STATUS_NG;
};

type ReturnType = {
  isHidden?: boolean;
  isLoading: boolean;
  postUserData: (userId: string, value: boolean, url: string) => Promise<void>;
};

export const useUserHidden = (initialValue?: boolean): ReturnType => {
  const [isHidden, setIsHidden] = useState(initialValue);
  const [isLoading, setIsLoading] = useState(false);

  const postUserData = async (userId: string, value: boolean, url: string) => {
    try {
      setIsLoading(true);

      const { data } = await axios.post<Response>(url, {
        authenticityToken: csrfToken(),
        formClientFrontendHidden: {
          userId: userId || "",
          on: value ? HIDDEN_OFF : HIDDEN_ON,
        },
      });

      if (data.status !== STATUS_OK) {
        sendErrorLog(new Error(data.exception || "非表示処理に失敗しました"));
        alert("非表示の処理に失敗しました。時間をおいて再度お試しください。");
        return;
      }
      if (data.data.on === HIDDEN_ON) {
        setIsHidden(true);
        window.location.reload();
        return;
      }
      setIsHidden(false);
      window.location.reload();
    } catch (error) {
      // AxiosErrorをそのまま渡し、sendErrorLog内の通信断（ERR_NETWORK）除外を効かせる
      sendErrorLog(error as Error);
      alert("通信に失敗しました。時間をおいて再度お試しください。");
    } finally {
      // サーバがエラー（status !== OK）を返した場合も含め、必ずローディングを解除する
      setIsLoading(false);
    }
  };

  return { isHidden, isLoading, postUserData };
};
